import { render, staticRenderFns } from "./user.vue?vue&type=template&id=e294f86c&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=e294f86c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e294f86c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e294f86c')) {
      api.createRecord('e294f86c', component.options)
    } else {
      api.reload('e294f86c', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=e294f86c&scoped=true&", function () {
      api.rerender('e294f86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/search/user.vue"
export default component.exports